/**
 * Generic quoted amount row (delivery fee, platform fee, etc.) with loader (#1416).
 */

import { Group, Loader, Text } from '@mantine/core';
import { semanticColors } from '../../config/theme';
import { formatUsd } from '../../utils/formatUsd';

export interface PriceSummaryQuotedAmountLineProps {
  label: string;
  amountUsd?: number | null;
  loading?: boolean;
  /** When true, show loader even if amountUsd is set (non-final quote). */
  amountPending?: boolean;
  loadingAriaLabel: string;
  dimmed?: boolean;
  testId?: string;
}

/**
 * One label + amount row; loader when the quote is not final.
 */
export function PriceSummaryQuotedAmountLine({
  label,
  amountUsd = null,
  loading = false,
  amountPending = false,
  loadingAriaLabel,
  dimmed = false,
  testId,
}: PriceSummaryQuotedAmountLineProps) {
  const showLoader = loading || amountPending || amountUsd == null;

  if (!showLoader && amountUsd <= 0) {
    return null;
  }

  return (
    <Group justify="space-between" wrap="nowrap" data-testid={testId}>
      <Text size="sm" c={dimmed ? 'dimmed' : semanticColors.text.secondary}>
        {label}
      </Text>
      {showLoader ? (
        <Loader size="xs" aria-label={loadingAriaLabel} />
      ) : (
        <Text size="sm" fw={500} aria-label={`${label} ${formatUsd(amountUsd)}`}>
          {formatUsd(amountUsd)}
        </Text>
      )}
    </Group>
  );
}
